import { useBasemapSwitch } from '../hooks'

const BasemapSwitch = ({ mapId, position, next }) => {
  useBasemapSwitch(mapId, position, next)

  return null
}

export default BasemapSwitch